<template>
  <div>
    <page-head
      :title="title"
      :btn-list="btnList"
      :show-back="false"
      @handleBtn="handleBtn"
    ></page-head>
    <div class="content">
      <div class="search">
        <i-form ref="search" :model="query">
          <row :gutter="80">
            <i-col span="6">
              <form-item label="姓名" prop="userName">
                <Input
                  v-model="query.userName"
                  clearable
                  placeholder="请输入"
                />
              </form-item>
            </i-col>

            <i-col span="6">
              <form-item label="派驻类别">
                <Cascader
                  v-model="partyTypePlaceholder"
                  :data="partyTypeLocalList"
                  placeholder="请选择"
                  clearable
                  @on-change="partyTypeChange"
                  change-on-select
                ></Cascader>
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="审核状态">
                <Select v-model="query.isCheck" clearable>
                  <Option
                    v-for="item in statusList"
                    :key="item.index"
                    :value="item.index"
                    :label="item.status"
                  ></Option>
                </Select>
              </form-item>
            </i-col>
          </row>
        </i-form>
      </div>
      <div class="table-wrapper">
        <div class="table-head-btn">
          <Button class="bkcc-btn del-btn" @click="handleBtn('deleteBatch')"
            >删除</Button
          >
          <Button class="bkcc-btn del-btn" @click="handleBtn('add')"
            >新增</Button
          >
          <Button class="bkcc-btn del-btn" @click="handleBtn('checkBatch')"
            >审核通过</Button
          >
        </div>
        <i-table
          :columns="tableHeader"
          :border="true"
          :loading="isTableLoading"
          :data="tableData"
          @on-selection-change="handleSelect"
          stripe
          ref="table"
        >
          <template slot-scope="{ row }" slot="partyTypeList">
            <span v-if="row.partyTypeList">
              {{ formatPartyType(row.partyTypeList) }}
            </span>
            <span v-if="!row.partyTypeList">
              {{ formatPartyType(row.partyTypeName) }}
            </span>
          </template>
          <template slot-scope="{ row }" slot="isCheck">
            <span v-if="row.isCheck === 0" class="waiting-color">待审核</span>
            <span v-if="row.isCheck === 1" class="pass-color">已通过</span>
            <span v-if="row.isCheck === 2" class="not-color">审核未通过</span>
            <span v-if="row.isCheck === 3" class="past-color">已归档</span>
          </template>
          <template slot-scope="{ row }" slot="action">
            <span @click="handleTableAction('detail', row)" class="action"
              >[详情]</span
            >
            <span @click="handleTableAction('edit', row)" class="action"
              >[编辑]</span
            >
            <span
              v-if="row.isCheck === 0 || row.isCheck === 2"
              @click="handleTableAction('passSingle', row)"
              class="action"
              >[审核通过]</span
            >
            <span
              v-if="row.isCheck === 1"
              @click="handleTableAction('past', row)"
              class="action"
              >[归档]</span
            >
            <span
              v-if="row.isCheck === 3"
              @click="handleTableAction('restore', row)"
              class="action"
              >[还原]</span
            >
            <span @click="handleTableAction('deleteSingle', row)" class="action"
              >[删除]</span
            >
          </template>
        </i-table>
        <div class="page">
          <page
            :total="total"
            :current="pageNum"
            @on-change="pageChange"
            show-total
          />
        </div>
      </div>
    </div>
    <Modal v-model="modalIsOpen" title="审核通过" :width="550">
      <div>
        审核通过原因（选填）
      </div>
      <!-- <template v-if="currentPassSingleId">
        <div class="title">审核编号：</div>
        <row>
          <i-col span="12">
            <div class="model-num">{{ currentPassSingleId }}</div>
          </i-col>
        </row>
      </template>
      <template v-else>
        <div class="title">审核编号：</div>
        <row>
          <template :gutter="0" v-for="(item, index) in selectedList">
            <i-col span="12" :key="index">
              <div class="model-num">{{ item }}</div>
            </i-col>
          </template>
        </row>
      </template> -->
      <br />
      <Input
        type="textarea"
        v-model="checkMsg"
        :rows="5"
        placeholder="请输入原因..."
      />
      <div slot="footer">
        <Button style="margin-right:10px" @click="modalIsOpen = false"
          >取消</Button
        >
        <Button type="primary" @click="auditHandler" :loading="isBtbLoading"
          >确定</Button
        >
      </div>
    </Modal>
  </div>
</template>

<script>
import pageHead from "../../../components/head";
import api from "../../../api/index";
const {
  exportChiefWaiterExcel,
  postChiefWaiterList,
  deleteChiefWaiter,
  postBatchAuditWaiter,
  postChiefWaiter
} = api;
import { getPartyTypeDic } from "./dic";
export default {
  name: "waiterManager",
  components: {
    pageHead
  },
  data() {
    return {
      currentPassSingleId: "",
      currentIsCheck: 0,
      statusList: [
        {
          index: 0,
          status: "待审核"
        },
        {
          index: 1,
          status: "已通过"
        },
        {
          index: 2,
          status: "审核未通过"
        },
        {
          index: 3,
          status: "归档"
        }
      ],
      partyTypePlaceholder: [],
      partyTypeLocalList: [],
      title: "用户管理",
      checkMsg: "",
      modalTitle: "",
      modalIsOpen: false,
      isBtbLoading: false,
      btnList: [
        {
          name: "搜索",
          type: "search"
        },
        {
          name: "重置",
          type: "reset"
        },
        {
          name: "导出",
          type: "export"
        }
      ],
      query: {
        userName: "",
        isCheck: "",
        partyTypeList: "",
        partyType: null
      },
      pageNum: 1,
      pageSize: 10,
      total: 0,
      isTableLoading: false,
      tableHeader: [
        {
          type: "selection",
          width: 60,
          align: "center"
        },
        {
          title: "姓名",
          key: "userName"
        },
        {
          title: "联系电话",
          key: "phoneNO"
        },
        {
          title: "派驻类别",
          slot: "partyTypeList"
        },
        {
          title: "服务企业",
          key: "companyNames"
        },
        {
          title: "状态",
          slot: "isCheck"
        },
        {
          title: "操作",
          width: 280,
          slot: "action"
        }
      ],
      tableData: [],
      selectedList: [],
      header: {
        token: window.sessionStorage.getItem("token")
      }
    };
  },
  computed: {
    formatPartyType() {
      return function(type) {
        const levelArr = type.split(",");
        let name = "";
        this.partyTypeLocalList.filter(item => {
          if (item.value === levelArr[0]) {
            name = item.label;
            if (levelArr[1] && item.children) {
              item.children.filter(inner => {
                if (inner.value === levelArr[1]) {
                  name = name + "/" + inner.label;
                }
              });
            }
          }
          return;
        });
        // console.log("看看处理后的数据：", name);
        return name;
      };
    }
  },
  methods: {
    // 搜索 重置 导出逻辑
    handleBtn(type) {
      const handler = this[type + "Handler"];
      handler && handler();
    },
    // 重置处理
    resetHandler() {
      this.pageNum = 1;
      this.query.isCheck = "";
      this.query.partyType = null;
      this.query.partyTypeList = "";
      this.partyTypePlaceholder = [];
      this.currentPassSingleId = "";
      this.selectedList = [];
      this.$refs.search.resetFields();
      this.getList();
    },
    // 搜索处理
    searchHandler() {
      this.pageNum = 1;
      this.getList();
    },
    // 导出处理
    exportHandler() {
      let { userName, partyTypeList, isCheck } = this.query;
      console.log(partyTypeList);
      const url = `${exportChiefWaiterExcel}?userName=${userName}&partyTypeList=${partyTypeList}&isCheck=${isCheck}&token=${
        this.header.token
      }`;

      // const result = this.$get(url).then(data => window.open(data));
      // console.log(url);
      window.open(url);
    },
    // 删除批量处理
    deleteBatchHandler() {
      console.log("批量删除");
      if (this.selectedList.length == 0) {
        return this.$Message.warning("请选择要删除的条目");
      }
      this.removeHandler({ list: [1, 2, 3] });
    },
    // 新增人员处理
    addHandler() {
      console.log("新增");
      this.$router.push({ name: "addChiefWaiter" });
    },
    // 打开模态框
    openModal() {
      if (!this.modalIsOpen) {
        this.modalIsOpen = true;
        this.checkMsg = "";
      }
    },
    // 审核通过批量处理
    checkBatchHandler() {
      console.log("批量审核");
      this.currentPassSingleId = "";
      if (this.selectedList.length == 0) {
        return this.$Message.warning("请选择要审核的条目");
      }
      this.openModal();
    },
    // 分页变更获取相关数据
    pageChange(val) {
      this.pageNum = val;
      this.getList();
    },
    // 处理多选
    handleSelect(selection) {
      this.selectedList = [];
      // console.log(selection);
      selection.map(item => this.selectedList.push(item.id));
      // console.log(this.selectedList);
    },
    // 驻派类别变更时
    partyTypeChange(value) {
      const returndata = value[value.length - 1];
      this.query.partyTypeList = value.join(",");
      this.query.partyType = returndata;
      // console.log("驻派类别数据发生变化 ", returndata);
    },
    // 处理表格操作逻辑
    handleTableAction(type, params) {
      const handler = this[type + "Handler"];
      handler && handler(params);
    },
    // 详情处理逻辑
    detailHandler(row) {
      console.log("我是的tail");
      const { id } = row;
      this.$router.push({ name: "waiterManagerDetail", query: { id } });
    },
    // 编辑处理逻辑
    editHandler(row) {
      console.log("我是bianji");
      const { id } = row;
      this.$router.push({ name: "addChiefWaiter", query: { id } });
    },
    // 单条审核处理逻辑
    passSingleHandler(row) {
      console.log("我是单条审核通过");
      const { id } = row;
      this.currentPassSingleId = id;
      this.openModal();
    },
    // 归档处理逻辑
    pastHandler(row) {
      const { id } = row;
      this.singleAuditHandler(id, 3);
      console.log("我是归档");
    },
    // 还原处理逻辑
    restoreHandler(row) {
      console.log("我是还原");
      const { id } = row;
      this.singleAuditHandler(id, 0);
    },
    // 单条删除处理逻辑
    deleteSingleHandler(row) {
      console.log("我是单条删除");
      const { id } = row;
      this.removeHandler({ id });
    },
    // 审核操作处理逻辑
    async auditHandler() {
      const id = this.currentPassSingleId || "";
      const list = this.selectedList || [];
      // if (!this.checkMsg) {
      //   return this.$Message.info("请填写审核说明");
      // }
      this.isBtbLoading = true;
      try {
        let ids = id ? [id] : list;
        // console.log("看看传入的审核id", ids);
        const res = await this.$post(postBatchAuditWaiter, {
          remark: this.checkMsg || "",
          idList: ids.join(","),
          isCheck: 1
        });
        this.modalIsOpen = false;
        this.checkMsg = "";
        this.$Message.info("操作成功");
        this.getList();
      } finally {
        this.isBtbLoading = false;
        this.checkedId = "";
      }
    },
    // 单条审核处理
    async singleAuditHandler(id, isCheck) {
      this.isBtbLoading = true;
      try {
        const res = await this.$post(postChiefWaiter, {
          id,
          isCheck
        });
        if (res.isSucceed) {
          this.$Message.info("操作成功");
          this.getList();
        }
      } finally {
        this.isBtbLoading = false;
      }
    },
    // 删除操作处理函数
    removeHandler({ id = "", list = [] }) {
      console.log(id, list);
      const idList = id ? [id] : list;
      this.$Modal.confirm({
        title: "确定要删除？删除后不可恢复。",
        onOk: () => {
          this.deleteChiefWaiter(idList);
          // this.$Message.info("已经删除");
        }
      });
    },
    // 默认加载数据
    async getList() {
      const d = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        ...this.query
      };
      // console.log("看看传入的参数   ", d);
      let res = await this.$post(postChiefWaiterList, d);
      // console.log(this.query);
      // console.log("看看返回的数据 ", res);
      this.tableData = res.rows;
      this.total = res.total;
      // 此处模拟删除数据操作
      // this.tableData = res.rows.filter(item => item.isCheck !== 4);
      // this.total = this.tableData.length || 0;
    },
    // 获取驻派类别
    async getPartyTypeList() {
      const res = await this.$get(getPartyTypeDic);
      this.partyTypeLocalList = res.rows.length
        ? this.formateData(res.rows)
        : [];
    },
    // 格式化驻派类别数据
    formateData(data) {
      let returnData = data.map(item => {
        return {
          value: item.dicType,
          label: item.dicName,
          children: item.children.length ? this.formateData(item.children) : []
        };
      });
      return returnData;
    },
    // 删除服务
    async deleteChiefWaiter(idList) {
      const res = await this.$post(postBatchAuditWaiter, {
        idList: idList.join(","),
        isCheck: 4
      });
      if (res.isSucceed) {
        this.$Message.success("删除成功");
        this.getList();
      } else {
        this.$Message.error(res.message);
      }
    }
  },
  created() {
    this.getPartyTypeList();
    this.getList();
  }
};
</script>

<style lang="less" scoped>
.waiting-color {
  color: #e58450;
}
.pass-color {
  color: #5cc474;
}
.not-color {
  color: #f06052;
}
.past-color {
  color: #8cc64e;
}
.content {
  margin: 20px;
}
.search {
  width: 100%;
  background-color: white;
  border-radius: 5px;
  padding: 20px;
  margin-bottom: 20px;
}
.table-wrapper {
  height: 100%;
  position: relative;
  padding: 20px 20px 80px;
  background-color: #fff;
}
.page {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
}
.table-head-btn {
  margin-left: auto;
  width: fit-content;
  margin-bottom: 20px;
}
.action {
  margin: 0 5px;
}
.model-title {
  color: #ff7b44;
  font-weight: bold;
}

.model-num {
  color: #ff7b44;
  font-weight: 400;
  background: #ffefe9;
  margin: 0 15px 10px 0;
}
</style>
